export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-3">6789影院</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              热门综艺节目免费在线观看平台，高清流畅不缓冲。收录爆笑综艺、音乐选秀、真人秀等全品类综艺大全，每日更新即点即播。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-3">快速导航</h4>
            <ul className="space-y-2">
              {[
                { href: '#media', label: '精彩视频' },
                { href: '#ranking', label: '热门榜单' },
                { href: '#index', label: '综艺索引' },
                { href: '#faq', label: '常见问题' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-3">综艺分类</h4>
            <ul className="space-y-2">
              {['户外真人秀', '音乐竞演', '语言喜剧', '慢综艺', '推理探秘', '舞蹈竞技'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-100 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 6789影院 · 综艺节目免费在线观看 · 高清不缓冲即点即播
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-default">
              <i className="ri-wechat-line text-sm"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-default">
              <i className="ri-weibo-line text-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}